<nz-spin [nzSpinning]="isLoading | async" nzSize="large">
  <nz-layout>
    <nz-header>
      <nz-row nzJustify="space-between" nzAlign="middle">
        <nz-col>
          <h3><b>Notificações</b></h3>
        </nz-col>
        <nz-col *ngIf="selectedTabIndex === unreadTab">
          <button
            nz-button
            nzType="link"
            [nzLoading]="isLoading | async"
            (click)="markAllAsRead()"
          >
            Marcar todos como lido
          </button>
        </nz-col>
      </nz-row>

      <nz-tabset
        nzCentered
        nzSize="large"
        [nzSelectedIndex]="selectedTabIndex"
        (nzSelectedIndexChange)="onTabChange($event)"
      >
        <nz-tab nzTitle="Não lidas"></nz-tab>
        <nz-tab nzTitle="Visualizadas"></nz-tab>
      </nz-tabset>
    </nz-header>

    <nz-content>
      <div *ngFor="let notice of notices">
        <nz-row
          nzAlign="middle"
          nzJustify="space-between"
          class="notice"
          (click)="onNoticeClick(notice)"
          [ngClass]="{
            link: !!notice.link,
            warning: notice.status === status.SENT
          }"
        >
          <nz-col nzFlex="24px">
            <az_avatar icon="message" [src]="notice.photo" [size]="50" />
          </nz-col>

          <nz-col nzFlex="auto" style="max-width: calc(100% - 90px)">
            <nz-row>
              <nz-col nzSpan="24">
                <nz-row nzJustify="start" nzAlign="middle">
                  <nz-col>
                    <h3><b>{{ notice.title }}</b></h3>
                  </nz-col>
                  <nz-col>
                    <h3>{{ notice.subtitle }}</h3>
                  </nz-col>
                </nz-row>
              </nz-col>

              <nz-col nzSpan="24">
                <h4>{{ notice.content }}</h4>
              </nz-col>

              <nz-col nzSpan="24">
                <h5>{{ notice.createdAt | date : 'dd/MM/yyyy HH:mm:ss' }}</h5>
              </nz-col>
            </nz-row>
          </nz-col>

          <nz-col nzFlex="10px">
            <mat-icon *ngIf="notice.link">fiber_manual_record</mat-icon>
          </nz-col>
        </nz-row>
      </div>

      <nz-empty
        *ngIf="notices.length === 0"
        nzNotFoundContent="Não há notificações recentes."
      />
    </nz-content>
  </nz-layout>
</nz-spin>
